import React, { useContext } from 'react';
import { RoomContext } from '../context/RoomContext';
import Room from './Room';
import { SpinnerDotted } from 'spinners-react';
import BookForm from './BookForm';

const Rooms = () => {
  const { rooms, loading, searching } = useContext(RoomContext);

  return (
    <section className='py-20' style={{ background: '#FFFFE7' }}>
      {loading && rooms.length === 0 && (
        <div className='py-16 flex justify-center items-center'>
          <SpinnerDotted color='#a37d4c' />
        </div>
      )}

      <div className='container mx-auto lg:px-0 rounded-3xl p-6 shadow-xl bg-white/80'>
        {/* Page header */}
        <div className='flex flex-col items-center'>
          <div className='text-center mb-6'>
            <div className='font-tertiary uppercase text-[25px] tracking-[6px]'>
              Hotel & Restaurant
            </div>
            <h2 className='font-primary text-[45px]'>Room & Suites</h2>
          </div>

          {/* Booking Form */}
          <div className='w-full max-w-4xl'>
            <BookForm />
          </div>
        </div>

        <div className='grid grid-cols-1 max-w-sm mx-auto gap-[30px] lg:grid-cols-3 lg:max-w-none lg:mx-0 mt-8 relative min-h-[120px]'>
          {searching && (
            <div className='absolute inset-0 flex justify-center items-center bg-white/70 z-10 rounded-lg'>
              <SpinnerDotted color='#a37d4c' />
            </div>
          )}
          {Array.isArray(rooms) && rooms.length > 0 ? (
            rooms.map((room) => <Room room={room} key={room.id} />)
          ) : (
            <p className="text-center text-gray-500">
              No rooms available for the selected dates. Please try different dates or check back later.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Rooms;


